import { render, staticRenderFns } from "./AddContra.vue?vue&type=template&id=2860a3a9"
import script from "./AddContra.vue?vue&type=script&lang=js"
export * from "./AddContra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports